import nl from "@/config/locales/nl-NL.json";

/**
 * Property kinds come from the backend without a label (2026-11); the frontend
 * owns the translations under `property_kinds.<id>`. Unknown ids fall back to a
 * readable slug so a new backend kind never shows a raw i18n key.
 */
export function humanizePropertyKindId(id: string): string {
  const words = id.replace(/[-_]+/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function propertyKindLabel(
  t: (key: string, options: { defaultValue: string }) => string,
  id: string,
): string {
  return t(`property_kinds.${id}`, { defaultValue: humanizePropertyKindId(id) });
}

/** Ids the backend sends that have no `property_kinds.<id>` translation yet. */
export function findUntranslatedPropertyKindIds(
  ids: readonly string[],
  translations: Readonly<Record<string, string>> = nl.property_kinds,
): string[] {
  return ids.filter((id) => !Object.hasOwn(translations, id));
}

/**
 * Dev-only nudge to add missing translations to both locale files. Users still
 * see the humanized fallback, so this never throws.
 */
export function warnUntranslatedPropertyKinds(ids: readonly string[]): void {
  if (!import.meta.env.DEV) return;
  const missing = findUntranslatedPropertyKindIds(ids);
  if (missing.length === 0) return;
  console.warn(
    `[property-kinds] Missing translations for: ${missing.join(", ")}. ` +
      "Add them under `property_kinds` in src/config/locales/nl-NL.json and en-EN.json.",
  );
}
